import { updateMetricByKey } from '@client/core/atoms/metrics.js';
import { updatePlacementKeyValueById } from '@client/core/atoms/placements.js';
import {
  type PlacementId,
  PlacementStatus
} from '@schibsted-nmp/advertising-shared';

import { debug as _debug } from './.debug.js';

const debug = _debug.withSublabel('Event', 'slotRequested');

/** Fired when an ad has been requested for the ad slot. */
export function onSlotRequested(event: googletag.events.SlotRequestedEvent) {
  const placementId = event.slot.getSlotElementId() as PlacementId;

  debug.withPlacementLabel(placementId).message('').verbose();
  updatePlacementKeyValueById(placementId, 'creativeType', 'banner');
  updatePlacementKeyValueById(placementId, 'status', 'requested');
  updateMetricByKey(placementId, PlacementStatus.AdRequested);
}
